import React from 'react';
import DockDoorNumber from './DockDoorNumber';
import DockDoorSpots from './DockDoorSpots';
import { Trailer } from '../../types';

type BuildingProps = {
	doors: number[];
	trailers: Trailer[];
	dock: string;
	spotClicked: (door: any) => void;
	trailerClicked: (trailer: Trailer) => void;
	addOpen: () => void;
	tempModal: () => void;
};

export default function Building({
	doors,
	dock,
	trailers,
	spotClicked,
	trailerClicked,
	addOpen,
	tempModal,
	...props
}: BuildingProps) {
	//TODO: FIX NUMBER ISSUE LATER
	const reverseDoors = [...doors].reverse()
	return (
		<div {...props}>
			<div className="flex justify-between h-20" style={{justifyContent : "space-around", paddingRight:"3px", width: "calc(100vw - 4.75rem)",height:"7rem"  } } > 
				{reverseDoors.map((door: any) => {
					return (
						<DockDoorSpots
							key={door.id}
							trailers={trailers}
							dock={dock}
							door={door}
							trailerClicked={(trailer) => trailerClicked(trailer)}
							spotClicked={(door) => spotClicked(door)}
							addOpen={addOpen}
							tempModal={tempModal}
						/>
					);
				})}
			</div>
			<div className="flex justify-between h-10 border-black border-2 shadow-md" style={{justifyContent : "space-around" , width: "calc(100vw - 4.75rem)" }}>
				{reverseDoors.map((door: any) => {
					return <DockDoorNumber key={door.id} door={door.name} />;
				})}
			</div>
		</div>
	);
}
